<div app-block-container [children]="block.children"></div>
